import { trpc, trpcUtils } from "@editor/utils/trpc";

import { errorToast } from "@replo/design-system/components/alert/Toast";
import { useNavigate } from "react-router-dom";

export function useCreateFunnel() {
  const navigate = useNavigate();

  const {
    mutateAsync: createFunnelFromTemplate,
    isPending: createFunnelFromTemplateLoading,
  } = trpc.funnel.createFromTemplate.useMutation();

  const { mutateAsync: createFunnel, isPending: createFunnelLoading } =
    trpc.funnel.create.useMutation();

  const handleCreateFunnel = async ({
    projectId,
    name,
    funnelTemplateId,
  }: {
    projectId: string;
    name: string;
    funnelTemplateId?: string;
  }) => {
    try {
      let funnelId: string;
      if (funnelTemplateId) {
        const data = await createFunnelFromTemplate({
          projectId,
          funnelTemplateId,
          name,
        });
        funnelId = data.funnelId;
      } else {
        const data = await createFunnel({
          projectId: projectId ?? "",
          name,
        });
        funnelId = data.id;
      }

      void trpcUtils.funnel.list.invalidate({ projectId });
      void trpcUtils.webContainer.getFileTree.invalidate({
        projectId,
      });
      navigate(`/shops/${projectId}/funnels/${funnelId}`);
    } catch {
      errorToast("Error creating funnel", "Please try again");
    }
  };

  return {
    handleCreateFunnel,
    isLoading: createFunnelFromTemplateLoading || createFunnelLoading,
  };
}
